import { getStartEndTimeFromAudioSummaryMetadata } from '@modules/feedback/components/AudioType/utils';
import { SummaryMessageUnit } from 'generated/graphql';
import { FeedbackLabel } from 'v2/core/entities/feedback';
import { AudioConversationMessage } from 'v2/core/entities/feedback/content';
import { ReasonLabel } from 'v2/core/entities/feedback/labels';
import { UUID } from 'v2/core/entities/uuid';

export const generateReasonSummaryTextMap = (
  feedbackLabels: FeedbackLabel[],
  keywordSummaryUnitsMap: Map<UUID, SummaryMessageUnit[]>,
  audioConversation: AudioConversationMessage[],
) => {
  const reasonSummaryTextMap = new Map<
    UUID,
    { summaryText: string; summaryStartTime: number }[]
  >();

  const reasonLabels = feedbackLabels.filter(
    (label): label is ReasonLabel => label.type === 'REASON',
  );

  if (!reasonLabels.length) {
    return reasonSummaryTextMap;
  }

  reasonLabels.forEach((label) => {
    if (label.reasonUnits?.length) {
      label.reasonUnits.forEach((unit) => {
        if (unit.type === 'KEYWORD_SUMMARY') {
          const existingValue = reasonSummaryTextMap.get(label.id);

          const summaryUnit = keywordSummaryUnitsMap.get(
            unit.keywordSummaryLabelID,
          )?.[unit.msgIDx];

          const { startTime } = getStartEndTimeFromAudioSummaryMetadata(
            summaryUnit?.metadata,
            audioConversation,
          );

          const valueToAdd = {
            summaryText: summaryUnit?.text ?? '',
            summaryStartTime: startTime,
          };

          if (!existingValue) {
            reasonSummaryTextMap.set(label.id, [valueToAdd]);
          } else {
            const doesSummaryAlreadyExist = existingValue.some(
              (value) => value.summaryText === valueToAdd.summaryText,
            );
            if (!doesSummaryAlreadyExist) {
              const sortedValue = [...existingValue, valueToAdd].sort(
                (a, b) => a.summaryStartTime - b.summaryStartTime,
              );
              reasonSummaryTextMap.set(label.id, sortedValue);
            }
          }
        }
      });
    }
  });

  return reasonSummaryTextMap;
};
